module.exports = __webpack_public_path__ + "static/media/vcb.a9533ceb.png";